<div class="rl-overlay-fullscreen" *ngIf="isVisible">
  <div class="rl-overlay-content">


    <!-- Título -->
    <h2 class="rl-overlay-title">Límite de Solicitudes Alcanzado</h2>

    <!-- Mensaje -->
    <p class="rl-overlay-message">
      Has excedido el límite de peticiones permitidas.
      <br>
      La página se recargará automáticamente cuando finalice el tiempo de espera.
    </p>

    <!-- Contador de tiempo con spinner animado -->
    <div class="rl-time-display">
      <div class="rl-spinner-container">
        <!-- Círculo base -->
        <svg class="rl-circular-spinner" viewBox="0 0 200 200">
          <!-- Círculo de fondo -->
          <circle class="rl-spinner-track" cx="100" cy="100" r="85"></circle>
          <!-- Círculo animado rojo -->
          <circle class="rl-spinner-circle-1" cx="100" cy="100" r="85"></circle>
          <!-- Círculo animado gris -->
          <circle class="rl-spinner-circle-2" cx="100" cy="100" r="85"></circle>
          <!-- Círculo animado amarillo -->
          <circle class="rl-spinner-circle-3" cx="100" cy="100" r="85"></circle>
        </svg>
        <!-- Contenido del contador -->
        <div class="rl-time-text">
          <span class="rl-time-number">{{ timeRemaining }}</span>
          <span class="rl-time-label">seg</span>
        </div>
      </div>
      <p class="rl-time-description">
        Podrás continuar navegando en <strong>{{ formatTime(timeRemaining) }}</strong>
      </p>
    </div>

    <!-- Spinner animado -->
    <div class="rl-spinner">
      <div class="rl-spinner-circle"></div>
      <div class="rl-spinner-circle"></div>
      <div class="rl-spinner-circle"></div>
    </div>
  </div>
</div>
